import React from 'react';
import './Spinner.css';
import logo from '../../../assets/logo/logo.png';

const spinner = () => (
    
    <div className='loader'>Loading..
    <div className="Ideatech"></div><img className='LogoIdeatech' alt='logo' src={logo}></img></div>
    
)

export default spinner;